import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取OMS_WAREHOUSE_INFO 仓库内装
export function warehouseInfoList(params) {
  return request({
    url: URL.seaExport.warehouseInfo,
    method: 'get',
    params
  })
}
// 仓库信息更新
export function updateWarehuseInfo(data) {
  return request({
    url: URL.seaExport.warehouseInfo,
    method: 'post',
    data
  })
}

// 进仓编号列表
export function getJobWarehouseNos(params) {
  return request({
    url: URL.seaExport.getJobWarehouseNos,
    method: 'get',
    params
  })
}
